<div
  class="relative cursor-pointer inline-block"
  (click)="isRevealed = !isRevealed"
  #myTooltip
  tooltip="{{ isRevealed ? 'Conceal' : 'Reveal' }} Key"
  id="toggleRevealButton"
>
  {{ isRevealed ? secretValue : displayValue }}
</div>
